import {useRouter} from 'next/router';
import NextLink from 'next/link';
import {DeezerLogo, HStack} from '@tempo/core';

import {LAYOUT_PX} from '@modules/landing/layout';
import {tLocal} from '@modules/i18n/localStrings';
import {buildAbsolutePublicUrl} from '@modules/seo/urls';

export const AppHeader = () => {
	const router = useRouter();
	const redirectURL = buildAbsolutePublicUrl({
		locale: router.locale ?? router.defaultLocale,
		path: '/',
	});

	return (
		<HStack
			as="header"
			data-testid="AppHeader"
			justify="space-between"
			align="center"
			h={['64px', null, null, '80px']}
			px={LAYOUT_PX}
			borderBottom="1px solid"
			borderColor="border.neutral.primary.default"
		>
			<NextLink
				href={redirectURL}
				data-testid="AppHeader-brand"
				aria-label={tLocal('local_footer_branding')}
				style={{textDecoration: 'none', display: 'inline-flex'}}
			>
				<DeezerLogo data-testid="AppHeader-deezer-logo" h="32px" />
			</NextLink>
		</HStack>
	);
};
